import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Base64 } from 'js-base64';
import { CitySelectionService } from '../../services/city-selection.service';
import { filterCityOptions } from '../../shared/city-search/city-filter';

@Component({
    selector: 'app-cities-from',
    templateUrl: './cities-from.component.html',
    styleUrls: ['./cities-from.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CitiesFromComponent implements OnInit  {
  searchControl = new FormControl('');
  allCities: string[] = []; // Your list of cities
  filteredCities: string[] = [];
  
  topcities: string[] = ['Nairobi', 'Mombasa', 'Kisumu','Busia','Kampala','Nakuru','Kigali']; // Add your cities
  selectedField: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private citySelection: CitySelectionService
  ) { }
  destinations: string[] = [];
  ngOnInit() {

    const citiesEncoded = localStorage.getItem('mashpoa-cities');
    if (citiesEncoded) {
      const citiesString = Base64.decode(citiesEncoded);
      const citiesArray = JSON.parse(citiesString); // Assuming this is an array of cities

      this.allCities = [...new Set([...this.topcities, ...citiesArray])];
      this.filteredCities = [...this.allCities]; // Update filteredCities with allCities data
    }

    this.route.queryParams.subscribe(params => {
      this.selectedField = params['field'];
  
    });
    this.searchControl.valueChanges.subscribe(searchValue => {
      this.filteredCities = this.filterCities(searchValue);
    });


  }

  filterCities(searchValue: string | null): string[] {
    return filterCityOptions(searchValue, this.allCities, this.topcities);
  }

  selectCity(city: string) {

    if (this.selectedField === 'from') {
      this.citySelection.setLeavingFrom(city);
    } else if (this.selectedField === 'to') {
      this.citySelection.setGoingTo(city);
    }
    this.router.navigate(['/']); // navigate back to the form
  }
}
